var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorCircle = function SvgErrorCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.968 1.333C4.31 1.333 1.333 4.324 1.333 8A6.674 6.674 0 0 0 8 14.667 6.674 6.674 0 0 0 14.666 8c0-3.676-3.004-6.667-6.698-6.667m.032 12A5.34 5.34 0 0 1 2.666 8c0-2.94 2.378-5.333 5.302-5.333 2.959 0 5.365 2.392 5.365 5.333A5.34 5.34 0 0 1 8 13.333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.333 4.667h1.333v4.666H7.333zm0 5.333h1.333v1.333H7.333z"
  })));
};
export default SvgErrorCircle;